/**
 * 헤더의 "해봄 체험하기" 버튼을 누르면 뜨는 참여자 유형 선택 모달.
 * 14세 미만은 `/play`(학교·학년·닉네임 입력), 14세 이상은 `/play1`(이름·소속·연락처 입력)로 보낸다.
 * `BaseDialog` 를 그대로 써서 ESC·배경 클릭·포커스 트랩을 별도 구현 없이 물려받는다.
 */
import React from "react";
import { useRouter } from "next/router";
import BaseDialog from "./BaseDialog";

interface ExhibitionAgeSelectModalProps {
    isOpen: boolean;
    onClose: () => void;
}

const ExhibitionAgeSelectModal: React.FC<ExhibitionAgeSelectModalProps> = ({ isOpen, onClose }) => {
    const router = useRouter();

    const handleSelect = (path: "/play1" | "/play") => {
        onClose();
        router.push(path);
    };

    return (
        <BaseDialog
            isOpen={isOpen}
            onClose={onClose}
            ariaLabel="해봄 체험하기 — 참여자 유형 선택"
            widthClassName="w-full max-w-[480px]"
            containerClassName="bg-white rounded-[16px] p-8 shadow-lg"
        >
            <div className="text-center mb-8">
                <h2 className="text-22 font-bold text-strong mb-2 font-heading">해봄 체험하기</h2>
                <p className="text-15 text-muted">참여자 유형을 선택해 주세요.</p>
            </div>

            <div className="space-y-3">
                <button
                    type="button"
                    onClick={() => handleSelect("/play")}
                    data-autofocus
                    className="w-full p-5 rounded-[12px] border-2 border-line-subtle hover:border-primary hover:bg-primary-soft transition-colors text-left focus-visible:ring-2 focus-visible:ring-primary-focus focus-visible:outline-none"
                >
                    <div className="text-17 font-bold text-strong">14세 미만(학생)</div>
                    <div className="text-13 text-disabled mt-1">학교·학년·닉네임으로 참여해요.</div>
                </button>
                <button
                    type="button"
                    onClick={() => handleSelect("/play1")}
                    className="w-full p-5 rounded-[12px] border-2 border-line-subtle hover:border-primary hover:bg-primary-soft transition-colors text-left focus-visible:ring-2 focus-visible:ring-primary-focus focus-visible:outline-none"
                >
                    <div className="text-17 font-bold text-strong">14세 이상(일반)</div>
                    <div className="text-13 text-disabled mt-1">이름·소속·연락처로 참여해요.</div>
                </button>
            </div>

            <button
                type="button"
                onClick={onClose}
                className="w-full mt-6 py-3 text-15 font-medium text-muted hover:text-strong transition-colors focus-visible:ring-2 focus-visible:ring-primary-focus focus-visible:outline-none rounded-md"
            >
                닫기
            </button>
        </BaseDialog>
    );
};

export default ExhibitionAgeSelectModal;
